import { type Dispatch, useCallback, useState } from 'react';

export default (defaultValue: string): [string, Dispatch<string>] => {
  const [value, setValue] = useState(defaultValue);
  const trimValue = useCallback((newValue: string) => setValue(newValue.trim()), []);
  return [value, trimValue];
};
